import React, { useEffect, useState } from 'react';
import LoginIntro from '../components/LoginIntro/LoginIntro';
import { Amplify, Hub, Auth, I18n } from 'aws-amplify';
import { useLocation, useHistory } from 'react-router-dom';
import awsconfig from '../aws-exports';
import { AmplifyAuthenticator, AmplifySignIn, AmplifySignUp, AmplifyForgotPassword, AmplifyConfirmSignUp, AmplifyRequireNewPassword } from '@aws-amplify/ui-react';
// import Cookies from 'js-cookie';
import { cx, css } from '@emotion/css';

Amplify.configure(awsconfig);

I18n.putVocabularies({
  en: {
    'Incorrect username or password.': 'Incorrect password. If this is your first time logging in after our upgrade, please click Forgot Password to reset your account.',
  },
});

const authContainer = cx(css`
  opacity: 0;
  visibility: hidden;
  transition: opacity 500ms 100ms, visibility 500ms 100ms;
  // border: 2px solid red;
  // margin-top: 20px;
  position: relative; /* Ensure it's positioned properly */
  // z-index: 1100 !important; /* Navbar (1000) se upar */
  
  &.is-show {
    opacity: 1;
    visibility: visible;
  }
`);



function LoginPage() {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {

    const getTokenByEvent = (data) => {
      switch (data.payload.event) {
        case 'signIn': {
          if (location.pathname === '/login') {
            history.push('/practiceevents'); // Navigate first
            setTimeout(() => window.location.reload(), 0); // Reload after navigation
          }
          break;
        }
        default:
          break;
      }
    };


    Hub.listen('auth', getTokenByEvent);
  }, [location, history]);

  const signInFields = [
    {
      type: 'username',
      label: 'Username',
      placeholder: 'Please enter your username',
      required: true,
    },
    {
      type: 'password',
      label: 'Password',
      placeholder: 'Please enter your Password',
      required: true,
    },
  ];

  const signUpFields = [
    {
      type: 'username',
      label: 'Username',
      placeholder: 'Please enter your Username',
      required: true,
    },
    {
      type: 'email',
      label: 'Email',
      placeholder: 'Please enter your Email',
      required: true,
    },
    {
      type: 'password',
      label: 'Password',
      placeholder: 'Please enter your Password',
      required: true,
    },
  ];

  const resetpassword = [
    {
      type: 'username',
      label: 'Username',
      placeholder: 'Please enter your Username',
      required: true,
    },
  ];

  const [elm, setElm] = useState(null);

  return (
    <AmplifyAuthenticator
      className={`auth-form-container ${authContainer} ${elm ? 'is-show' : ''}`}
      usernameAlias="username"
    >
      <div slot="sign-in">
        <LoginIntro setElm={setElm}>
          <AmplifySignIn
            headerText="Sign in"
            slot="sign-in"
            usernameAlias="username"
            formFields={signInFields}
            className="auth-form"
          >
            <div slot="federated-buttons"></div>
          </AmplifySignIn>
        </LoginIntro>
      </div>

      <div slot="sign-up">
        <LoginIntro setElm={setElm}>
          <AmplifySignUp
            headerText="Sign Up"
            slot="sign-up"
            usernameAlias="username"
            className="auth-form"
            formFields={signUpFields}
          ></AmplifySignUp>
        </LoginIntro>
      </div>

      <div slot="forgot-password">
        <LoginIntro setElm={setElm}>
          <AmplifyForgotPassword className="auth-form" slot="forgot-password" />
        </LoginIntro>
      </div>

      <div slot="confirm-sign-up">
        <LoginIntro setElm={setElm}>
          <AmplifyConfirmSignUp className="auth-form" slot="confirm-sign-up" />
        </LoginIntro>
      </div>

      <div slot="require-new-password">
        <LoginIntro setElm={setElm}>
          <AmplifyRequireNewPassword className="auth-form" slot="require-new-password" />
        </LoginIntro>
      </div>
    </AmplifyAuthenticator>
  );
}

export default LoginPage;